/** A lista de respostas rápidas (a mesma para quem atende e para quem administra). */
export const quickRepliesKey = ['quick-replies'] as const;
